import { Images_Demo } from '~images'
import { NftType } from '~types/nfts'
import { generateID } from '~utils'

export const nfts: NftType[] = [
  {
    brand: 'Adidas',
    id: generateID(),
    image:
      'https://images.unsplash.com/photo-1654183818269-22495f928eb1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
    imageBg: 'rgba(0, 136, 245, 0.15)',
    logo: Images_Demo.LOGO_ADIDAS,
    name: 'gold head',
    type: 'Collectible',
    validUntil: new Date('2022-11-15'),
    year: '2021',
  },
  {
    brand: 'Douglas',
    id: generateID(),
    image:
      'https://images.unsplash.com/photo-1658981370004-6d64bf8e7d7e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1632&q=80',
    imageBg: 'rgba(108, 245, 0, 0.15)',
    logo: Images_Demo.LOGO_DOUGLAS,
    name: 'The heart',
    type: 'Membership',
    validUntil: new Date('2022-11-30'),
    year: '2020',
  },
  {
    brand: 'Douglas',
    id: generateID(),
    image:
      'https://images.unsplash.com/photo-1656381620321-bddff61435c3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=715&q=80',
    logo: undefined,
    name: 'Astronaut',
    type: 'Collectible',
    validUntil: new Date('2022-11-30'),
    year: '2020',
  },
  {
    brand: 'Douglas',
    id: generateID(),
    image:
      'https://images.unsplash.com/photo-1654792393225-3e8a53d124d2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1632&q=80',
    logo: undefined,
    name: 'Head the great',
    type: 'Collectible',
    validUntil: new Date('2022-11-30'),
    year: '2020',
  },
  {
    brand: 'Douglas',
    id: generateID(),
    image:
      'https://images.unsplash.com/photo-1634986666676-ec8fd927c23d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=735&q=80',
    logo: undefined,
    name: 'Arystoteles',
    type: 'Collectible',
    validUntil: new Date('2022-11-30'),
    year: '2020',
  },
  {
    brand: 'Douglas',
    id: generateID(),
    image:
      'https://images.unsplash.com/photo-1651601787600-40ad979813ac?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=764&q=80',
    logo: undefined,
    name: 'Butterfly on the head',
    type: 'Membership',
    validUntil: new Date('2022-11-30'),
    year: '2020',
  },
  {
    brand: 'Douglas',
    id: generateID(),
    image: undefined,
    logo: undefined,
    type: 'Collectible',
    validUntil: new Date('2022-11-30'),
    year: '2020',
  },
  {
    brand: 'Douglas',
    id: generateID(),
    image: undefined,
    logo: undefined,
    type: 'Collectible',
    validUntil: new Date('2022-11-30'),
    year: '2020',
  },
  {
    brand: 'Douglas',
    id: generateID(),
    image: undefined,
    logo: undefined,
    type: 'Collectible',
    validUntil: new Date('2022-11-30'),
    year: '2020',
  },
]
